// extracted by mini-css-extract-plugin
export default {"verticalResizer":"p0mcw5HMog5KJiN2WWIW","resizeBar":"aI7CSu8YpnXWT7Zu0dNb"};